import type * as React from 'react';
import { cn } from '@/shared/lib/cn';

export function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('px-(--card-spacing)', className)} {...props} />;
}
